var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function Svg403(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 984,
    height: 638,
    viewBox: "0 0 984 638",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M202.856 498.659H287.653V424.124H340.044V350.669H287.113V116.262H178.551L23 347.969V424.124H202.856V498.659ZM111.038 350.669L201.776 209.161H203.396V350.669H111.038Z",
    fill: "#DBFCFD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M506.659 508.921C614.68 508.921 655.729 414.942 655.729 306.38C655.729 198.359 614.68 106 506.659 106C398.097 106 356.509 198.359 356.509 306.38C356.509 414.942 398.097 508.921 506.659 508.921ZM506.659 431.145C458.589 431.145 449.407 355.53 449.407 306.38C449.407 258.311 458.589 182.695 506.659 182.695C554.188 182.695 562.83 258.311 562.83 306.38C562.83 355.53 554.188 431.145 506.659 431.145Z",
    fill: "#DBFCFD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M824.504 508.921C894.718 508.921 968.713 471.113 968.713 387.397C968.713 344.728 938.467 309.081 895.258 298.819V297.198C932.526 287.476 959.531 256.15 959.531 214.022C959.531 140.567 892.558 106 825.044 106C761.311 106 700.819 138.947 682.456 203.22L766.713 222.663C772.654 196.738 793.178 179.995 819.103 179.995C843.948 179.995 867.173 194.578 867.173 222.123C867.173 258.851 834.226 267.492 800.199 267.492H773.734V333.926H798.039C835.846 333.926 875.814 345.268 875.814 384.156C875.814 419.803 846.108 432.766 820.183 432.766C785.616 432.766 762.392 410.621 755.37 385.236L671.113 407.381C691.637 478.675 754.83 508.921 824.504 508.921Z",
    fill: "#DBFCFD"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M763.576 524.468L728.95 512.775L749.499 512.774L786.415 524.468L763.576 524.468Z",
    fill: "#DBFCFD"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M698.94 505.635L662.631 498.413L683.091 497.043L715.869 504.087L698.94 505.635Z",
    fill: "#DBFCFD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M582 482.5C727 489 869 546.5 952 627",
    stroke: "#007288",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33 628C102.523 560.841 233.136 507.589 371 487.5",
    stroke: "#007288",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64 628C64 628 114 579 186.072 555.591",
    stroke: "#007288",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M101.794 80.9088C104.845 80.0015 106.582 76.7928 105.675 73.742C104.768 70.6913 101.559 68.9537 98.5083 69.861C95.4575 70.7684 93.7199 73.977 94.6273 77.0278C95.5346 80.0786 98.7433 81.8162 101.794 80.9088Z",
    fill: "#91D6DB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M946.81 568.691C949.86 567.783 951.598 564.575 950.691 561.524C949.783 558.473 946.575 556.735 943.524 557.643C940.473 558.55 938.736 561.759 939.643 564.81C940.55 567.86 943.759 569.598 946.81 568.691Z",
    fill: "#91D6DB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M333.647 116.608C354.827 116.608 371.996 99.4391 371.996 78.2598C371.996 57.0804 354.827 39.9111 333.647 39.9111C312.468 39.9111 295.299 57.0804 295.299 78.2598C295.299 99.4391 312.468 116.608 333.647 116.608Z",
    fill: "#91D6DB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M291.205 93.0343C300.774 112.139 324.019 119.869 343.124 110.3C362.229 100.73 369.959 77.4852 360.389 58.3804C350.82 39.2756 327.575 31.5456 308.47 41.115C289.365 50.6844 281.635 73.9295 291.205 93.0343Z",
    stroke: "#007288",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M300.768 46.2033C285.386 37.805 274.44 33.5642 272.876 35.9755C270.381 39.7773 293.133 59.3768 323.811 79.692C354.49 100.007 381.381 113.376 383.929 109.548C385.537 107.092 377.368 98.6451 362.749 87.1587",
    stroke: "#007288",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M295.827 51.2296C281.484 43.5431 272.949 40.6904 271.49 42.8729C268.995 46.6746 291.747 66.2742 322.408 86.5982C353.069 106.922 380.004 120.291 382.526 116.454C384.23 113.884 376.123 105.472 360.281 93.2564",
    stroke: "#007288",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M88.4849 451.211L99.6963 457.348L88.4849 463.485L82.3482 474.677L76.2114 463.485L65 457.348L76.2114 451.211L82.3482 440L88.4849 451.211Z",
    fill: "#92D7DC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M592.5 643L524.625 626.25L534.625 614.25L600 632L592.5 643Z",
    fill: "#DBFCFD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M604.375 626.25L540.25 606.625L554.625 594L616.625 612.5L604.375 626.25Z",
    fill: "#DBFCFD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M623.375 603.875L562.125 584.25L574.625 574.625L634.375 592.5L623.375 603.875Z",
    fill: "#DBFCFD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M644.125 580.875L585.25 564.25L597.875 556.375L654.375 571.125L644.125 580.875Z",
    fill: "#DBFCFD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M664.375 565.625L607.625 550L623.25 542.75L678.5 556.75L664.375 565.625Z",
    fill: "#DBFCFD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M687.25 551.75L631.625 536.25L647.875 531L701.75 546L687.25 551.75Z",
    fill: "#DBFCFD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M709.75 540.625L658 527.125L679 522.625L724.375 535.75L709.75 540.625Z",
    fill: "#DBFCFD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M737.499 531.125L698.501 519.375L713.624 517.125L754.5 528.5L737.499 531.125Z",
    fill: "#DBFCFD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M473 628L393.001 615L410.185 602.446L485 613.5L473 628Z",
    fill: "#DBFCFD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M493.501 607L418.501 594L436.501 582L508.5 592.693L493.501 607Z",
    fill: "#DBFCFD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M521.001 585.5L447 575.001L468.001 564L539.001 573.5L521.001 585.5Z",
    fill: "#DBFCFD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M549 564.5L485 554.5L504.5 545L564.5 556.5L549 564.5Z",
    fill: "#DBFCFD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M576 548L517 538L535.5 531L592 541L576 548Z",
    fill: "#DBFCFD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M601.5 535.5L547 526L568.5 518.5L619.5 528L601.5 535.5Z",
    fill: "#DBFCFD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M628.5 523L579.5 514L599 509L647.5 518L628.5 523Z",
    fill: "#DBFCFD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M664.5 513L619 503.5L642.5 500.5L683.5 508L664.5 513Z",
    fill: "#DBFCFD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M277.681 549.173C277.681 549.173 302.785 553.575 299.963 570.564C297.14 587.552 275.129 605.501 275.129 605.501C275.129 605.501 316.369 590.056 322.312 568.064C322.31 568.113 327.584 539.042 277.681 549.173Z",
    fill: "#DBFCFD"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.34,
    d: "M274.004 607.073C306.018 594.894 327.554 573.409 322.105 559.086C316.656 544.762 286.286 543.024 254.272 555.203C222.257 567.382 200.722 588.867 206.171 603.19C211.62 617.514 241.99 619.252 274.004 607.073Z",
    stroke: "#007288",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M397.702 526.875C397.702 526.875 415.856 530.34 413.777 542.068C412.353 550.095 401.758 557.291 401.758 557.291C401.758 557.291 421.111 551.687 424.479 541.392C424.479 541.392 427.535 528.401 397.702 526.875Z",
    fill: "#DBFCFD"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.34,
    d: "M391.451 559.463C410.851 556.814 425.61 547.578 424.416 538.833C423.222 530.089 406.527 525.148 387.127 527.796C367.727 530.445 352.968 539.681 354.162 548.426C355.356 557.17 372.051 562.112 391.451 559.463Z",
    stroke: "#007288",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.69,
    d: "M668.672 108.953C680.089 108.953 689.345 99.6976 689.345 88.2806C689.345 76.8637 680.089 67.6084 668.672 67.6084C657.255 67.6084 648 76.8637 648 88.2806C648 99.6976 657.255 108.953 668.672 108.953Z",
    fill: "#91D6DB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M687.229 97.3445C698.646 97.3445 707.901 88.0892 707.901 76.6722C707.901 65.2553 698.646 56 687.229 56C675.812 56 666.557 65.2553 666.557 76.6722C666.557 88.0892 675.812 97.3445 687.229 97.3445Z",
    stroke: "#007288",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M488 113L492.5 121.5",
    stroke: "#007288",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M578 93L582.5 101.5",
    stroke: "#007288",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M154.5 137.5L25.5 331.5",
    stroke: "#007288",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 179.301,
    y1: 230.382,
    x2: 137.382,
    y2: 295.699,
    stroke: "#007288",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M278 132L278 338",
    stroke: "#007288",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 278,
    y1: 441,
    x2: 278,
    y2: 486,
    stroke: "#007288",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M194 440L194 499L278.5 499",
    stroke: "#007288",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M194 209L194 350L102.5 350L126 313.5",
    stroke: "#007288",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M195 424H14.5",
    stroke: "#007288",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M277.5 116L195 116",
    stroke: "#007288",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14 354L14 424",
    stroke: "#007288",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M278.5 424L331 424L331 351H277",
    stroke: "#007288",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M959.6 387.397C959.6 471.113 885.605 508.921 815.391 508.921C804.21 508.921 793.197 508.142 782.5 506.54M815.931 106C752.198 106 691.706 138.947 673.342 203.22L735 217.5M757.599 222.663C763.54 196.738 784.065 179.995 809.99 179.995M858.059 222.123C858.059 258.851 825.113 267.492 791.086 267.492H764.621V333.926H788.926C826.733 333.926 866.701 345.268 866.701 384.156C866.701 404.962 856.581 418.04 843 425.323M856.872 110.591C908.679 121.705 950.418 155.138 950.418 214.022C950.418 256.15 923.413 287.476 886.145 297.198V298.819C909.105 304.272 928.405 316.893 941.452 333.926M732.5 491.535C699.529 475.606 673.76 448.232 662 407.381L746.257 385.236C750.484 400.52 760.586 414.629 775.5 423.438",
    stroke: "#007288",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M347.509 306.38C347.509 244.457 361.175 187.681 393.29 150.5M440.407 306.38C440.407 258.311 449.589 182.695 497.659 182.695C545.188 182.695 553.83 258.311 553.83 306.38C553.83 355.53 545.188 431.145 497.659 431.145C464.727 431.145 450.047 395.656 444.067 357.5M428.619 122C447.74 111.728 470.623 106 497.659 106C518.909 106 537.567 109.574 553.83 116.138M351.449 361.5C364.077 444.9 408.056 508.921 497.659 508.921C542.238 508.921 575.411 492.915 599 466.484M636.478 392.5C643.502 366.106 646.729 336.816 646.729 306.38C646.729 281.064 644.474 256.608 639.631 234",
    stroke: "#007288",
    strokeWidth: 2,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M455 397L562.23 149.841M477 425L590.699 161.263M594.141 153.129L610.996 113.299L582.456 100.998L565.193 142.688",
    stroke: "#007288",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M654.403 185.186C629.153 174.437 603.561 164.338 577.929 154.392C577.498 154.213 577.079 154.062 576.648 153.883C548.371 142.884 520.035 132.028 492.013 120.533C490.499 123.822 489.142 127.2 487.772 130.549C474.577 162.946 461.391 195.324 448.176 227.713C441.198 244.883 434.2 262.045 427.202 279.207C454.226 291.825 482.022 302.648 509.747 313.586C535.873 323.907 561.939 334.371 587.231 346.58C598.475 319.333 609.752 292.411 620.987 265.473C632.133 238.81 643.278 212.146 654.403 185.186ZM538.819 293.735C531.799 293.53 525.237 292.049 519.263 289.563C499.431 281.308 485.999 262.015 483.358 241.682C478.917 207.498 502.361 170.038 550.039 173.485C556.209 173.937 562.063 175.268 567.411 177.349C567.871 177.517 568.323 177.705 568.774 177.893C587.745 185.788 600.7 202.984 603.706 221.978C605.519 233.479 604.075 245.572 599.521 256.515C590.651 277.827 570.016 294.65 538.819 293.735Z",
    fill: "#91D6DB",
    stroke: "#007288",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 543.046,
    cy: 232.375,
    r: 50.8558,
    fill: "#91D6DB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M567.537 169.205L567.558 169.213C568.058 169.395 568.553 169.601 569.071 169.816C590.395 178.691 604.955 198.022 608.332 219.359C610.372 232.3 608.747 245.914 603.621 258.232C593.65 282.19 570.467 301.124 535.301 300.092L535.271 301.092L535.3 300.092C527.413 299.862 520.045 298.198 513.338 295.407C491.062 286.136 475.943 264.439 472.97 241.56C470.47 222.313 475.824 202.161 488.483 187.321C501.121 172.506 521.095 162.915 548.002 164.86C554.947 165.37 561.529 166.867 567.537 169.205ZM577.953 203.407C578.237 203.279 578.445 203.028 578.517 202.726C578.589 202.424 578.516 202.105 578.321 201.864C570.76 192.546 559.38 185.989 545.662 185.015C526.967 183.661 512.923 190.339 504.009 200.79C495.116 211.215 491.384 225.328 493.143 238.775C493.197 239.197 493.26 239.593 493.32 239.972L493.321 239.974C493.37 240.281 493.559 240.548 493.833 240.696C494.106 240.844 494.433 240.856 494.717 240.729L577.953 203.407ZM536.898 279.817C554.844 280.353 568.421 273.381 577.151 262.961C585.862 252.564 589.709 238.778 588.317 225.718C588.289 225.453 588.156 225.21 587.948 225.043C587.74 224.876 587.474 224.8 587.209 224.83L586.227 224.943C586.125 224.955 586.026 224.982 585.932 225.024L505.839 260.938C505.768 260.97 505.701 261.01 505.639 261.058L504.226 262.143C504.007 262.31 503.867 262.561 503.84 262.835C503.814 263.083 503.883 263.33 504.029 263.529C504.056 263.573 504.086 263.615 504.119 263.654C511.902 272.946 523.305 279.412 536.898 279.817ZM504.074 263.586L504.074 263.585L504.078 263.59L504.078 263.59L504.077 263.589L504.076 263.588L504.074 263.586Z",
    fill: "white",
    stroke: "#007288",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M427 279L423 271L487.6 111.933L648.82 175.856L654.5 185",
    stroke: "#007288",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M611 113L608 105.5L578 92L559.156 139.637",
    stroke: "#007288",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M488.523 305.814L452.5 389.5",
    stroke: "#007288",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 984,
    height: 638,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(Svg403);
export default __webpack_public_path__ + "static/media/403.fa10dc5150e4744ed27388939d2fa5ce.svg";
export { ForwardRef as ReactComponent };